import React from "react";
import AgentCard from "./AgentCard";
import "./AgentsSection.css";
import SectionHeader from "../Sections/SectionHeader";


export default function AgentsSection() {
  return (
    <section className="agents-section">
<SectionHeader
  title={`Every Experience,<br/>Powered by an Agent.`}
  subtitle={`AI Squared creates intelligent agents designed to make hospitality, dining, and wellness experiences feel seamless, human, and effortlessly luxurious.`}
/>


      <div className="agents-grid">
        <AgentCard
          title="Reception’s Assistant"
          subtitle="(Hotels)"
          description="Your all-in-one guest relations agent. Handles check-ins, room service, and post-stay feedback — all via WhatsApp."
          bullets={[
            "Connected to PMS & dashboards",
            "Personalized guest recognition",
          ]}
          buttonText="Meet EVA Concierge"
          gradient="linear-gradient(160deg, #52DFFF 0%, #1EB8E4 50%, #0A8FC3 100%)"
          iconColor="#7FF8FF"
        />

        <AgentCard
          title="Chef’s Assistant"
          subtitle="(Restaurants)"
          description="Your restaurant’s AI-powered table manager. Handles reservations, menu automation, and guest communication — all through WhatsApp."
          bullets={[
            "Handles WhatsApp orders",
            "Tracks wait time and service quality",
          ]}
          buttonText="See Chef’s Assistant"
          gradient="linear-gradient(160deg, #FFD580 0%, #EAA74B 50%, #D88C3D 100%)"
          iconColor="#F6C256"
          darkButton
        />

        <AgentCard
        title="Wellness Assistant"
        subtitle="(Clinics & Spas)"
        description="AI-powered scheduling, client follow-ups, and loyalty management for wellness brands."
        bullets={[
            "Automated booking reminders",
            "Personalized post-session follow-ups",
        ]}
        buttonText="Meet Wellness Assistant"
        gradient="linear-gradient(145deg, #E9B8FF 0%, #E3A6FF 40%, #E48C71 100%)"
        iconColor="#F6B7FF"
        />

      </div>
    </section>
  );
}
